import React from 'react';
import { TableRow, TableCell, Typography, Tooltip } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import VisibilityIcon from '@material-ui/icons/Visibility';
import StageProgress from './StageProgress';
import InactivityCell from './InactivityCell';
import { formatTrackerDate, repDisplayName } from '../utils';
import { TEXT, TruncatedText } from '../../shared_components';

const OngoingRow = ({ plan, onAdvanceStage, onCloseProject, onView }) => {
  const isFinalStage = plan?.progress && plan.progress.current === plan.progress.total;
  const lessorLessee = [plan?.lessor?.name, plan?.lessee?.name].filter(Boolean).join(' · ');
  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" style={{ fontWeight: 600, color: TEXT.primary }}><TruncatedText text={plan?.name} maxWidth={240} /></Typography>
        <Typography variant="caption" style={{ color: TEXT.tertiary }}>{plan?.asset_count} asset{plan?.asset_count === 1 ? '' : 's'}</Typography>
      </TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}><TruncatedText text={lessorLessee} maxWidth={180} /></Typography></TableCell>
      <TableCell>
        <StageProgress stageName={plan?.current_stage?.name} current={plan?.progress?.current} total={plan?.progress?.total} />
      </TableCell>
      <TableCell><InactivityCell inactivity={plan?.inactivity} /></TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}><TruncatedText text={repDisplayName(plan?.lead)} maxWidth={140} /></Typography></TableCell>
      <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{formatTrackerDate(plan?.planned_end_date)}</Typography></TableCell>
      <TableCell align="right">
        {isFinalStage ? (
          <Tooltip title="Close" arrow>
            <CheckCircleIcon color="primary" fontSize="small" style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => onCloseProject(plan)} />
          </Tooltip>
        ) : (
          <Tooltip title="Advance Stage" arrow>
            <ArrowForwardIcon color="primary" fontSize="small" style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => onAdvanceStage(plan)} />
          </Tooltip>
        )}
        <Tooltip title="View" arrow>
          <VisibilityIcon color="primary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => onView(plan)} />
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default OngoingRow;
